import React from 'react';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';

import translations, { resolveLocale } from './locales.js';
import { flattenMessages } from './flatten.js';

// merge over en-GB so a key missing from a locale renders the English
// string instead of the raw message id
const getMessages = (locale) => ({
    ...flattenMessages(translations['en-gb']),
    ...flattenMessages(translations[locale] || {}),
});

export const IntlWrapper = ({ children, locales }) => {
    const selectedLocale = resolveLocale(locales.locale);
    const messages = getMessages(selectedLocale);

    return (
        <IntlProvider locale={selectedLocale} messages={messages}>
            {children}
        </IntlProvider>
    );
};

export const getIntl = (locales) => {
    const locale = resolveLocale(locales.locale);
    const messages = getMessages(locale);
    const { intl } = new IntlProvider({ locale, messages }, {}).state;

    return intl;
};

export default connect(({ locales }) => ({ locales }))(IntlWrapper);
